export default "__VITE_ASSET__Bva29Xsu__"